// extracted by mini-css-extract-plugin
export default {"no-messages":"VoiceMessages_no-messages__jJVLT"};